import { useState, useEffect } from 'react'

/**
 * Delays showing loading state to prevent flash of loading content
 * when data loads quickly. If data loads within the delay period,
 * the loading state is never shown.
 *
 * @param isLoading - Whether data is currently loading
 * @param delay - Milliseconds to wait before showing loading state (default: 150ms)
 */
export function useDeferredLoading(isLoading: boolean, delay = 150): boolean {
  const [showLoading, setShowLoading] = useState(false)

  useEffect(() => {
    if (isLoading) {
      const timer = setTimeout(() => {
        setShowLoading(true)
      }, delay)
      return () => clearTimeout(timer)
    } else {
      setShowLoading(false)
    }
  }, [isLoading, delay])

  return isLoading && showLoading
}
